import { Loader } from "@caprikorn/dynamo-ui";
import type { FC } from "react";
import { useSearchParams } from "react-router-dom";

import { LS_KEYS } from "@core/core.constants";
import { useLoginRedirect } from "@hooks/useLoginRedirect";
import { parseJwt } from "@utils/auth.utils";

import classes from "./LoginCameleon.module.css";
import type { CameleonToken } from "./LoginCameleon.types";

export const LoginCameleon: FC = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  if (token) {
    const data: CameleonToken = parseJwt(token);
    localStorage.setItem(LS_KEYS.CURRENT_GROUP_REF, "");
    localStorage.setItem(LS_KEYS.ACCESS_TOKEN, token);
    localStorage.setItem(LS_KEYS.EMAIL, data.emailCustomer);
    localStorage.setItem(LS_KEYS.CAMELEON_EMAIL, data.emailCameleon);
    localStorage.setItem(LS_KEYS.CAMELEON_FULL_NAME, data.fullnameCameleon);
  }
  useLoginRedirect();

  return (
    <div className={classes.container}>
      <Loader />
    </div>
  );
};
